import { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";

export default function ReportesInventario() {
  const [tipoReporte, setTipoReporte] = useState("stock_actual");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [formatoExportacion, setFormatoExportacion] = useState("pdf");

  const tiposReporte = [
    { value: "stock_actual", label: "Stock Actual" },
    { value: "stock_bajo", label: "Productos con Stock Bajo" },
    { value: "valor_inventario", label: "Valor de Inventario" },
    { value: "movimientos", label: "Movimientos de Inventario" },
    { value: "rotacion", label: "Rotación de Productos" },
    { value: "kardex", label: "Kardex de Productos" },
    { value: "inventario_fisico", label: "Inventario Físico" },
    { value: "productos_inactivos", label: "Productos Inactivos" },
  ];

  const handleGenerarReporte = () => {
    console.log("Generando reporte:", {
      tipo: tipoReporte,
      fechaInicio,
      fechaFin,
      formato: formatoExportacion,
    });
    // Aquí iría la lógica para generar el reporte
  };

  const handleExportar = (formato) => {
    console.log("Exportando en formato:", formato);
    // Aquí iría la lógica para exportar
  };

  // Datos de ejemplo para el reporte
  const columns = [
    { Header: "Producto", accessor: "producto", align: "left" },
    { Header: "Categoría", accessor: "categoria", width: "15%", align: "left" },
    { Header: "Stock", accessor: "stock", width: "12%", align: "center" },
    { Header: "Precio Unit.", accessor: "precio", width: "12%", align: "right" },
    { Header: "Valor Total", accessor: "valor", width: "15%", align: "right" },
    { Header: "Almacén", accessor: "almacen", width: "15%", align: "left" },
  ];

  const rows = [
    {
      producto: "Producto A",
      categoria: "Electrónica",
      stock: "150 UND",
      precio: "$25.00",
      valor: "$3,750.00",
      almacen: "Almacén Central",
    },
    {
      producto: "Producto B",
      categoria: "Alimentos",
      stock: "85 KG",
      precio: "$12.50",
      valor: "$1,062.50",
      almacen: "Almacén Norte",
    },
  ];

  return (
    <MDBox>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <MDTypography variant="h6">Reportes de Inventario</MDTypography>
      </MDBox>

      {/* Panel de Configuración del Reporte */}
      <Card sx={{ mb: 3 }}>
        <MDBox p={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                select
                label="Tipo de Reporte"
                value={tipoReporte}
                onChange={(e) => setTipoReporte(e.target.value)}
              >
                {tiposReporte.map((tipo) => (
                  <MenuItem key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                type="date"
                label="Fecha Inicio"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                type="date"
                label="Fecha Fin"
                value={fechaFin}
                onChange={(e) => setFechaFin(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={handleGenerarReporte}
                sx={{ height: "100%" }}
              >
                Generar
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </Card>

      {/* Resultados del Reporte */}
      <Card>
        <MDBox
          p={3}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          borderBottom="1px solid #e0e0e0"
        >
          <MDTypography variant="h6">Resultados del Reporte</MDTypography>
          <MDBox display="flex" gap={1}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<Icon>picture_as_pdf</Icon>}
              onClick={() => handleExportar("pdf")}
            >
              PDF
            </Button>
            <Button
              variant="outlined"
              size="small"
              startIcon={<Icon>table_view</Icon>}
              onClick={() => handleExportar("excel")}
            >
              Excel
            </Button>
            <Button
              variant="outlined"
              size="small"
              startIcon={<Icon>print</Icon>}
              onClick={() => window.print()}
            >
              Imprimir
            </Button>
          </MDBox>
        </MDBox>
        <MDBox>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>
      </Card>

      {/* Resumen de Estadísticas */}
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={2} textAlign="center">
              <MDTypography variant="h4" color="info">
                2,450
              </MDTypography>
              <MDTypography variant="caption" color="text">
                Total de Productos
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={2} textAlign="center">
              <MDTypography variant="h4" color="success">
                $458,750
              </MDTypography>
              <MDTypography variant="caption" color="text">
                Valor Total
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={2} textAlign="center">
              <MDTypography variant="h4" color="warning">
                45
              </MDTypography>
              <MDTypography variant="caption" color="text">
                Stock Bajo
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={2} textAlign="center">
              <MDTypography variant="h4" color="error">
                12
              </MDTypography>
              <MDTypography variant="caption" color="text">
                Sin Stock
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}
